// Relative imports
import $ from 'jquery';
import iframeResize from 'iframe-resizer/js/iframeResizer';

// Absolute imports
import BaseComponent from './baseComponent';

/**
 * Auto-Height for all iframes
 */
export default class IframeHeightResizer extends BaseComponent {
  /**
     * Public constructor
     *
     * @param options
     */
  constructor(options) {
    super(options);

    this.$iframeParagraphs = $('.paragraph--type--iframe');
    this.$iframes = null;

    if (this.$iframeParagraphs.length > 0) {
      this.$iframes = this.$iframeParagraphs.find('iframe');
    }

    return this;
  }

  /**
     * Initialize function
     */
  init() {
    if (this.$iframes && this.$iframes.length > 0) {
      $.each(this.$iframes, (index, iframe) => {
        const { id } = iframe;
        if (iframe.src.indexOf('vpfs') !== -1) {
          iframeResize({ log: true }, `#${id}`);
        }
      });
    }
  }
}
